<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import { Toast } from 'vant';
import localStorage from '@/util/storage';
export default {
  name: 'App',
  created() {
      document.title = '工作安排';
      let urlParams = new URLSearchParams(window.location.search);
      // console.log("11", urlParams);
      let paramValue = urlParams.get('tenantId');
      let defaultValue = '847595';
      let result = paramValue || defaultValue;
      console.log(result); 
      localStorage.saveLocal("tenantId", result);
      // 缓存tenantId
      // console.log("22", paramValue);
  },  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #FAF8F7;
}
</style>
